import { ValidatorFn } from '@angular/forms';

export const termsValidator: ValidatorFn = (control) => {
  const checked = control.value;
  if (checked) {
    return null;
  }
  return {
    unchecked: '利用規約およびプライバシーポリシーに同意してください。',
  };
};
